import { rootApi } from 'root-api'

const TAG_TYPES = ['COLLECTION', 'EVENT_TYPE_COLLECTION']

const api = rootApi.enhanceEndpoints({ addTagTypes: TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    fetchCollection: build.query({
      query: ({ name, organization, currentUserId, ...params }) => ({
        url: `/api/reports/collections/${name}`,
        params: { organization, currentUserId, ...params }
      }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['COLLECTION']
    }),
    fetchEventTypesCollection: build.query({
      query: ({
        organization,
        currentUserId,
        page,
        term,
      }) => ({
        url: '/api/reports/collections/event_types',
        params: {
          organization,
          currentUserId,
          page,
          ...(term ? { term } : {}),
        }
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) => (
        currentArg?.page !== previousArg?.page
        || currentArg?.term !== previousArg?.term
      ),
      providesTags: ['EVENT_TYPE_COLLECTION']
    }),
    fetchEventTypesWithEventsCollection: build.query({
      query: ({
        organization,
        currentUserId,
        page,
        sort,
        order,
        start,
        end,
      }) => ({
        url: '/api/reports/collections/event_types',
        params: {
          organization,
          currentUserId,
          page,
          start,
          end,
          ...(sort ? { sort } : {}),
          ...(order ? { order } : {}),
        }
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) => (
        currentArg?.page !== previousArg?.page
        || currentArg?.start !== previousArg?.start
        || currentArg?.end !== previousArg?.end
        || currentArg?.order !== previousArg?.order
        || currentArg?.sort !== previousArg?.sort
      )
    }),
    fetchUsersWithEventsCollection: build.query({
      query: ({
        organization,
        currentUserId,
        page,
        sort,
        order,
        start,
        end,
      }) => ({
        url: '/api/reports/collections/users',
        params: {
          organization,
          currentUserId,
          page,
          start,
          end,
          ...(sort ? { sort } : {}),
          ...(order ? { order } : {}),
        }
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) => (
        currentArg?.page !== previousArg?.page
        || currentArg?.start !== previousArg?.start
        || currentArg?.end !== previousArg?.end
        || currentArg?.order !== previousArg?.order
        || currentArg?.sort !== previousArg?.sort
      )
    }),
  })
})

export const {
  useFetchCollectionQuery,
  useFetchEventTypesCollectionQuery,
  useFetchEventTypesWithEventsCollectionQuery,
  useFetchUsersWithEventsCollectionQuery
} = api
